import { queryOptions, QueryClient } from '@tanstack/react-query'
import { collectionsApi } from '@wtf/shared/api/collections'
import { normalizeCollection } from '@wtf/shared'

export const collectionQueryOptions = (
    queryClient: QueryClient,
    collectionId?: string
) =>
    queryOptions({
        queryKey: ['collection', collectionId],
        enabled: !!collectionId,
        queryFn: async () => {
            if (!collectionId) {
                throw new Error('Missing collectionId')
            }
            const dto = await collectionsApi.getCollectionById(collectionId)
            return normalizeCollection(queryClient, dto)
        },
        staleTime: 5 * 60 * 1000,
        refetchOnMount: 'always',
    })
